module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hollandsnieuwe-03@2x.6e8c37ed.jpg";